import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminAdvanceRateScreen from "../../../container/RateAdminScreen/RateAdminAdvanceRateScreen";
import CreateRateAdminAdvanceRate from "../../../container/RateAdminScreen/RateAdminAdvanceRateScreen/CreateRateAdminAdvanceRate";

const RateAdminAdvanceRateRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_ADVANCERATE.UPDATE}
          element={<CreateRateAdminAdvanceRate isUpdate={true} screenPermissions={access} />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_ADVANCERATE.EDIT}
          element={<CreateRateAdminAdvanceRate isEdit={true} isUpdate={true} screenPermissions={access} />}
        />
        )}
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_ADVANCERATE.HOME}
          element={<RateAdminAdvanceRateScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_ADVANCERATE.CREATE}
          element={<CreateRateAdminAdvanceRate screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_ADVANCERATE.COPY}
          element={<CreateRateAdminAdvanceRate isCopy={true} screenPermissions={access} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_ADVANCERATE.VIEW}
          element={<CreateRateAdminAdvanceRate isView={true} screenPermissions={access} />}
        />
      )}
    </>
  );
};

export default RateAdminAdvanceRateRoutes;
